<template>
  <el-card class="creative" :body-style="{ padding: '0' }">
    <div slot="header" class="header">
      <span>
        {{ $t('CampaignForm_InApp_Creative_Title') }} {{ index + 1 }}
      </span>
      <i
        class="delete-btn el-icon-delete"
        @click="onDelete"
        data-qa="creative-delete-btn"
      />
    </div>
    <div class="body">
      <el-row>
        <el-col>
          <form-item prop="prop" :label="$t('CampaignForm_InApp_Field_Upload')">
            <campaign-image-upload
              class="upload"
              :value="value.background_file"
              :file.sync="value.background_file"
              :message-type="channelTypes.inapp"
              upload-type="banner"
              size="small"
            />
          </form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <form-item
            prop="height"
            :label="$t('CampaignForm_InApp_Field_Height')"
          >
            <el-input
              @focus="clearDefaultHeight()"
              v-model="value.height"
              data-qa="creative-height-input"
            />
          </form-item>
        </el-col>
        <el-col :span="12">
          <form-item
            prop="action"
            :label="$t('CampaignForm_InApp_Field_Width')"
          >
            <el-input
              @focus="clearDefaultWidth()"
              v-model="value.min_width"
              data-qa="creative-width-input"
            />
          </form-item>
        </el-col>
      </el-row>
    </div>
  </el-card>
</template>

<script>
import FormItem from '@/common/components/form/FormItem'
import { channelTypes } from '@/modules/campaign-manage/enum/Labels'
import CampaignImageUpload from '@/modules/campaign-manage/components/content/CampaignImageUpload'
export default {
  name: 'InAppCreative',
  components: { CampaignImageUpload, FormItem },
  data() {
    return {
      channelTypes
    }
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    index: {
      required: true
    },
    onDelete: {
      type: Function,
      required: true
    }
  },
  methods: {
    clearDefaultHeight() {
      if (this.value.height === 0) {
        this.value.height = null
      }
    },
    clearDefaultWidth() {
      if (this.value.min_width === 0) {
        this.value.min_width = null
      }
    }
  }
}
</script>

<style scoped lang="scss">
/deep/ .el-card__header {
  padding: 16px;
  border-bottom: none;
}
.creative {
  background-color: #f8fafc;
  border: 1px solid #dbdee7;
  margin: 10px;
  box-shadow: none;
  .header {
    border-bottom: none;
    .delete-btn {
      float: right;
      padding: 3px 0;
      cursor: pointer;
      font-size: 16px;
      color: #a7acba;
    }
    span {
      font-weight: 600;
      font-size: 14px;
    }
  }
  .body {
    padding: 16px;
    padding-top: 0;
    .upload {
      width: 100%;
      /deep/ .el-upload {
        width: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/setup/InAppCreative.vue